import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinmulshi() {



  const cardData =
  {
    keyword: 'Bus Hire in Mulshi',
    heading: 'Sanavi Travels: Bus Hire in Mulshi',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire in Mulshi, providing safe, comfortable, and spacious transportation for families, groups, corporate outings, school excursions, weddings, and tourist travel to and from the scenic Mulshi region. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip bus hire packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Mulshi, Pune, and nearby areas, making it ideal for local sightseeing, outstation trips, corporate travel, and group tours. Choose Sanavi Travels for trusted bus hire services in Mulshi, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Mulshi Dam",
    "description": "Mulshi Dam is the main attraction of Mulshi, known for its vast backwaters, misty hills, and serene environment. Surrounded by lush greenery, the dam offers breathtaking views, especially during the monsoon season. It is a perfect getaway for nature lovers, photographers, and those seeking peace away from city life."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake is formed by the waters of Mulshi Dam and is famous for its calm waters and scenic surroundings. The lake reflects the Sahyadri hills, creating postcard-perfect views. It is ideal for relaxing, short walks, and enjoying quiet moments in nature."
  },
  {
    "title": "Tamhini Ghat",
    "description": "Tamhini Ghat is a picturesque mountain pass near Mulshi, known for waterfalls, dense forests, and winding roads. During the monsoon, the entire region comes alive with greenery and flowing streams. It is a favorite route for nature drives and monsoon trips."
  },
  {
    "title": "Devkund Waterfall",
    "description": "Devkund Waterfall is a stunning plunge waterfall located near Mulshi, popular among trekking enthusiasts. The trek passes through forests and river crossings, leading to a crystal-clear pool at the base of the waterfall. It is considered one of the most beautiful waterfalls in the Pune region."
  },
  {
    "title": "Andharban Forest Trek",
    "description": "Andharban, meaning ‘dark forest,’ is a famous jungle trek near Mulshi. The trail passes through dense forests, waterfalls, and valleys, offering a thrilling experience for adventure lovers. It is especially popular during the monsoon season."
  },
  {
    "title": "Kundalika Valley Viewpoints",
    "description": "The viewpoints around Mulshi and Tamhini offer panoramic views of valleys, rivers, and layered hills. These spots are perfect for sunset viewing, photography, and soaking in the raw beauty of the Western Ghats."
  },
  {
    "title": "Temghar Dam (Nearby)",
    "description": "Located close to Mulshi, Temghar Dam is another scenic water reservoir surrounded by hills and greenery. The peaceful environment makes it ideal for short visits and nature photography."
  },
  {
    "title": "Village Life Experience",
    "description": "Mulshi villages provide a glimpse into authentic rural Maharashtrian life. Traditional homes, farming landscapes, and local cuisine add cultural richness to the travel experience."
  },
  {
    "title": "Resorts and Nature Stays",
    "description": "Mulshi is known for its eco-resorts, luxury villas, and nature stays overlooking lakes and hills. These stays offer relaxation, wellness retreats, and weekend escapes from Pune and Mumbai."
  },
  {
    "title": "Birdwatching and Nature Trails",
    "description": "The forests and lakes around Mulshi are home to diverse bird species and wildlife. Nature trails and early morning walks provide excellent opportunities for birdwatching and reconnecting with nature."
  }
]
,



"services": [
{
"name": "Bus Hire in Mulshi",
"description": "Bus Hire in Mulshi offers dependable and comfortable bus rental services for local sightseeing, group outings, and outstation travel. With well-maintained buses, spacious seating, and experienced drivers, this service ensures safe, smooth, and enjoyable journeys for families, tourists, corporate groups, and event travelers in and around Mulshi."
},
{
"name": "Bus Rental Mulshi",
"description": "Bus Rental Mulshi provides flexible and convenient bus rental solutions tailored to different travel needs. Multiple seating options, clean interiors, transparent pricing, and professional drivers make it ideal for picnics, tours, corporate travel, and long-distance journeys from Mulshi."
},
{
"name": "AC Bus Mulshi",
"description": "AC Bus Mulshi ensures a cool and relaxing travel experience with fully air-conditioned buses designed for comfort. Perfect for long journeys, weekend trips, and group travel, these buses offer comfortable seating, smooth rides, and a pleasant atmosphere throughout the journey."
},
{
"name": "Luxury Bus Mulshi",
"description": "Luxury Bus Mulshi offers premium travel with high-end buses featuring pushback seats, ample legroom, and enhanced comfort. Ideal for VIP travel, corporate outings, destination events, and luxury tours, it elevates the overall group travel experience."
},
{
"name": "Picnic Bus Mulshi",
"description": "Picnic Bus Mulshi is specially designed for school trips, family picnics, and group outings to scenic spots around Mulshi. Spacious seating, safe travel arrangements, and reliable drivers ensure a fun, comfortable, and worry-free picnic journey."
},
{
"name": "Tourist Bus Mulshi",
"description": "Tourist Bus Mulshi caters to travelers exploring Mulshi, nearby hill stations, and popular tourist destinations. Flexible itineraries, knowledgeable drivers, and comfortable buses provide a convenient and enjoyable sightseeing experience."
},
{
"name": "Corporate Bus Mulshi",
"description": "Corporate Bus Mulshi provides organized and professional transportation for corporate meetings, team outings, conferences, and office travel. Timely pickups, disciplined drivers, and comfortable buses ensure smooth and efficient corporate journeys."
},
{
"name": "Affordable Bus Mulshi",
"description": "Affordable Bus Mulshi delivers budget-friendly bus rental services without compromising on safety or comfort. Ideal for families, schools, social groups, and religious tours, it combines economical pricing with dependable transportation."
},
{
"name": "Chauffeur Driven Bus Mulshi",
"description": "Chauffeur Driven Bus Mulshi ensures a stress-free travel experience with trained and professional drivers managing routes, traffic, and schedules. Passengers can relax and enjoy the journey, making it perfect for tours, events, and group travel."
},
{
"name": "Best Bus Service Mulshi",
"description": "Best Bus Service Mulshi is known for punctual service, clean buses, and a customer-focused approach. Suitable for picnics, corporate travel, tourist tours, and group outings, it guarantees reliable and comfortable transportation."
},
{
"name": "Group Travel Bus Mulshi",
"description": "Group Travel Bus Mulshi offers organized transportation for large groups such as friends, families, corporate teams, and tour groups. Spacious buses and coordinated travel planning ensure everyone travels together safely and comfortably."
},
{
"name": "Weekend Trip Bus Mulshi",
"description": "Weekend Trip Bus Mulshi provides convenient bus services for short getaways and weekend tours from Mulshi. Ideal for friends, families, and corporate groups looking for a relaxed and well-organized weekend travel experience."
},
{
"name": "Online Bus Booking Mulshi",
"description": "Online Bus Booking Mulshi allows quick and easy bus reservations with instant confirmation. Multiple bus options, flexible schedules, and a simple booking process help travelers plan their journeys efficiently and hassle-free."
},
{
"name": "Event Bus Mulshi",
"description": "Event Bus Mulshi offers dedicated transportation for weddings, parties, conferences, exhibitions, and special events. Reliable scheduling, comfortable buses, and professional drivers ensure smooth movement of guests and participants."
},
{
"name": "Mulshi Travel Bus",
"description": "Mulshi Travel Bus provides complete travel solutions for local sightseeing and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to tourists, families, corporate clients, and group travelers."
}
],
"tableData": [
["Bus Hire in Mulshi", "Bus Rental Mulshi"],
["AC Bus Mulshi", "Luxury Bus Mulshi"],
["Picnic Bus Mulshi", "Tourist Bus Mulshi"],
["Corporate Bus Mulshi", "Affordable Bus Mulshi"],
["Chauffeur Driven Bus Mulshi", "Best Bus Service Mulshi"],
["Group Travel Bus Mulshi", "Weekend Trip Bus Mulshi"],
["Online Bus Booking Mulshi", "Event Bus Mulshi"],
["Mulshi Travel Bus", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Mulshi with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus hire services in Mulshi, ideal for family outings, corporate events, school trips, and group tours."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Mulshi and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with routes around Mulshi, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus hire in Mulshi, including fuel, tolls, and driver allowances, with no unexpected fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus hire in Mulshi."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus hire packages based on your group size and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus hire in Mulshi."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire services in Mulshi?',
    answer: 'Yes, Sanavi Travels offers reliable bus hire services in Mulshi for various travel needs.'
  },
  {
    question: 'How can I book a bus in Mulshi?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for hire in Mulshi?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Mulshi?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes in and around Mulshi.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations in Mulshi?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations within Mulshi and surrounding areas.'
  },
  {
    question: 'Is the bus hire service in Mulshi available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock bus hire services in Mulshi to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus hire services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus hire bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your bus hire trip in Mulshi.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Shinde',
    feedback: 'We hired a bus in Mulshi from Sanavi Travels and had a wonderful trip. Comfortable bus and very professional service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali More',
    feedback: 'Excellent bus hire experience with Sanavi Travels in Mulshi—punctual, clean, and friendly driver.',
    rating: 5
  }
];










































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Bus Hire in Mulshi - Sanavi Travels",
  "description": "Sanavi Travels offers AC, luxury, and affordable buses for picnic, corporate, tourist, and group travel in Mulshi. Chauffeur-driven bus service with online booking for weekend trips, events, and tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "38"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Bus Hire in Mulshi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC, luxury, and affordable buses for picnic, corporate, tourist, and group travel in Mulshi. Chauffeur-driven bus service with online booking for weekend trips, events, and tours."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/128.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinmulshi;